module.exports = __webpack_public_path__ + "img/tricky-1.33e11837.jpg";